var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"churn-goodbye-page"},[_c('img',{staticClass:"margin-vertical-m success-lottie",attrs:{"src":require('@/assets/generic-success.png')}}),_vm._v(" "),_c('div',{staticClass:"ri-large-headline"},[_vm._v("החשבון שלך וכל הפרטים הקשורים אליו יימחקו תוך 48 שעות")])])
}
var staticRenderFns = []

export { render, staticRenderFns }